import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, finalize, map, of } from 'rxjs';
import { UserService } from '../services/user.service';
import { GlobalLoadingService } from '../services/global-loading.service';

export const userDataGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const loadingService = inject(GlobalLoadingService);
  const router = inject(Router);

  if (userService.isLoaded()) {
    return true;
  }

  loadingService.show();

  return userService.fetchMe().pipe(
    map(() => true),
    // Returning `false` here cancelled the navigation with no destination,
    // leaving the user on a blank page with the loading overlay up. Send them
    // to the error screen instead — it is outside the guarded tree, so it
    // cannot bounce back into another login attempt.
    catchError(() => of(router.parseUrl('/unauthorized'))),
    finalize(() => loadingService.hide()),
  );
};
